/** footer interactions */
(function(){
  'use strict';
  
  const footers = document.querySelectorAll('.footer-block');
  if (!footers.length) return;
  
  footers.forEach(footer => {
    // Enhanced social link interactions
    const socialLinks = footer.querySelectorAll('.footer-block__social-link');
    
    socialLinks.forEach(link => {
      // Add subtle hover sound feedback (optional)
      link.addEventListener('mouseenter', function() {
        // Could add subtle scale animation or sound feedback here
        this.style.transform = 'translateY(-2px) scale(1.02)';
      });
      
      link.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0) scale(1)';
      });
      
      // Track social media clicks for analytics
      link.addEventListener('click', function() {
        const socialName = this.getAttribute('aria-label') || 'social';
        
        // Google Analytics 4 event tracking (if available)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'social_click', {
            social_platform: socialName.toLowerCase(),
            event_category: 'footer',
            event_label: 'footer_social_navigation'
          });
        }
        
        // Debug logging
        if (window.console && typeof console.log === 'function') {
          console.log('Footer social click:', socialName);
        }
      });
    });
    
    // Track footer navigation clicks
    const navLinks = footer.querySelectorAll('.footer-block__sitemap-nav a');
    navLinks.forEach(link => {
      link.addEventListener('click', function() {
        const linkText = this.textContent.trim();
        
        // Google Analytics 4 event tracking (if available)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {
            event_category: 'footer',
            event_label: 'footer_navigation',
            value: linkText
          });
        }
      });
    });
    
    // Add smooth scroll for anchor links
    const anchorLinks = footer.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  });
  
})();
